module.exports = __webpack_public_path__ + "static/media/waiting_avatar.e3d030e1.svg";